import { render, staticRenderFns } from "./heart-filled.vue?vue&type=template&id=41736ba4"
import script from "./heart-filled.vue?vue&type=script&lang=js"
export * from "./heart-filled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports